import QuizzCard from './quizz-card';

export default QuizzCard;
